var _excluded = ["className", "type", "size", "prefix", "suffix"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from "../lib/utils";
var inputVariants = cva('flex w-full rounded-md shadow-xs border border-input focus:outline-none focus:ring-offset-0 focus:ring-transparent focus:shadow-focus dark:focus:shadow-focusPrimary focus:border-primary-200 dark:focus:border-primary-300 bg-background dark:bg-background-input text-md ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50', {
  variants: {
    size: {
      default: 'h-10 px-[12px] text-md',
      sm: 'h-10 px-[12px] text-md',
      md: 'h-11 px-[14px] text-md'
    }
  },
  defaultVariants: {
    size: 'default'
  }
});
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    type = _ref.type,
    size = _ref.size,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative w-full"
  }, prefix ? /*#__PURE__*/React.createElement("span", {
    className: "w-[20px] h-full absolute top-0 left-[12px] flex items-center justify-center cursor-pointer"
  }, prefix) : null, /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    className: cn(inputVariants({
      size: size
    }), className, prefix ? 'ps-[40px]' : '', suffix ? 'pe-[40px]' : ''),
    ref: ref
  }, props)), suffix ? /*#__PURE__*/React.createElement("span", {
    className: "min-w-[20px] h-full absolute top-0 right-[12px] flex items-center justify-center cursor-pointer"
  }, suffix) : null);
});
Input.displayName = 'Input';
export { Input };